import { RefreshCw, Undo2 } from 'lucide-react'

import { Button } from '@krp/ui-kit'
import type { ReactNode } from 'react'

import '../../../shared/uc1b/journals.css'
import { ReceiptsBrowser } from './ReceiptsBrowser'
import type { ReceiptsActions, ReceiptsVm } from '../model/types'
import './receipts.css'

/**
 * «Стандартный возврат» из РМК (RP-FB74, этап 2): поиск чека на тех же общих частях, что вкладка «Чеки» (`ReceiptsBrowser`):
 * дерево «Где смотрим», дни, фильтры и список чеков. Без выручки, итогов и графиков. Нажатие на чек раскрывает его товары — сверить
 * с покупателем; «Подробнее» (`actions.openReceipt`) открывает окно возврата `RefundScreen` - то же, что кнопка «Вернуть» в детализации чека. Экран получает vm и actions
 * и больше ничего.
 */
export function RefundSearchScreen({ vm, actions, receiptLines }: {
  vm: ReceiptsVm
  actions: ReceiptsActions
  /** Товары чека под раскрытой строкой (их читает binding). */
  receiptLines?: (receiptId: string) => ReactNode
}) {
  return (
    <section className="aqsi-journal" aria-labelledby="aqsi-refund-search-title">
      <header className="aqsi-journal__head">
        <h2 id="aqsi-refund-search-title">
          <Undo2 size={18} aria-hidden="true" /> Стандартный возврат · {vm.title}
        </h2>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} busy={vm.list.refreshing} onClick={actions.reload}>
          Обновить
        </Button>
      </header>
      <p className="aqsi-journal__note" role="note">
        Найдите день и чек, который возвращает покупатель: нажатие на строку покажет товары чека, а «Подробнее» откроет окно возврата. Позиции, цены, НДС и
        способ оплаты берутся из сохранённой копии чека.
      </p>
      <ReceiptsBrowser
        vm={vm}
        actions={actions}
        {...(receiptLines === undefined ? {} : { receiptLines })}
        multiDayText="Чеки показываются за один день. Чтобы увидеть чеки, выберите день: в списке дней ниже или на календаре."
      />
    </section>
  )
}
